import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCSelect } from 'rollup-allspark';
import { isEmpty, printf } from '../../../utils';
import { getEntity, getList, updateEntity } from '../actions';
import {
  CATEGORY_LIST,
  GET_BRAND_PROFILE_ROUTING,
  ITEM_LIST,
} from '../sagaMap';
import { makeSelectProperty } from '../selector';
import Selector from './Selector';

const Advanced = ({
  brands,
  getBrandProfileRouting,
  getCategories,
  getItems,
  selectedBranch,
  selectedBrand,
  selectedProfile,
  updateField,
}) => {
  const onBrandSelected = sb => {
    updateField({
      menus: [],
      categories: [],
      checkedCategories: [],
      checkedItems: [],
      items: [],
      itemSearchKey: '',
      selectedBrand: sb,
      selectedFilterMenu: null,
      selectedFilterCategory: null,
    });

    if (isEmpty(sb)) return;

    getCategories({
      ...CATEGORY_LIST,
      params: {
        businessID: sb.business_id,
        brandID: sb.id,
        branchID: selectedBranch.id,
      },
      callbackFn: cl => {
        const menuSet = new Set();
        const menuList = [];

        cl.forEach(c => {
          if (!isEmpty(c.linkedSections)) {
            c.linkedSections.forEach(ls => {
              if (!menuSet.has(ls.sectionID)) {
                menuSet.add(ls.sectionID);
                menuList.push(ls);
              }
            });
          }
        });

        updateField({
          menus: menuList,
        });
      },
    });

    getItems({
      ...ITEM_LIST,
      params: {
        businessID: sb.business_id,
        brandID: sb.id,
        branchID: selectedBranch.id,
      },
    });

    getBrandProfileRouting({
      ...GET_BRAND_PROFILE_ROUTING,
      url: printf(GET_BRAND_PROFILE_ROUTING.url, selectedProfile.id, sb.id),
      callbackFn: routingInfo => {
        if (!isEmpty(routingInfo)) {
          const {
            categories: checkedCategories = [],
            items: checkedItems = [],
          } = routingInfo || {};

          updateField({
            checkedCategories,
            checkedItems,
          });
        }
      },
    });
  };

  const brandEl = (() => {
    if (isEmpty(brands) || (!isEmpty(brands) && brands.length === 1)) {
      return null;
    }

    return (
      <div className="flex flex-col gap-y-2">
        <SCSelect
          title="Brand"
          options={brands}
          trackBy="id"
          customLabel={b => `${b.id}. ${b.title}`}
          placeholder="Select a Brand"
          className="w-full"
          value={selectedBrand}
          onSelect={onBrandSelected}
        />
      </div>
    );
  })();

  return (
    <div className="w-full flex flex-col gap-y-8 p-4 bg-white rounded-lg border border-grey">
      <div className="flex flex-col gap-y-4">
        <div className="flex items-center text-lg font-medium">
          Select Items
        </div>
        {brandEl}
      </div>
      <Selector />
    </div>
  );
};

Advanced.propTypes = {
  brands: PropTypes.array,
  getBrandProfileRouting: PropTypes.func,
  getCategories: PropTypes.func,
  getItems: PropTypes.func,
  selectedBranch: PropTypes.object,
  selectedBrand: PropTypes.object,
  selectedProfile: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  brands: makeSelectProperty('brands'),
  selectedBranch: makeSelectProperty('selectedBranch'),
  selectedBrand: makeSelectProperty('selectedBrand'),
  selectedProfile: makeSelectProperty('selectedProfile'),
});

const mapDispatchToProps = dispatch => ({
  getBrandProfileRouting: params => dispatch(getEntity(params)),
  getCategories: params => dispatch(getList(params)),
  getItems: params => dispatch(getList(params)),
  updateField: params => dispatch(updateEntity(params)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Advanced);
